export enum CoachingType {
    NON_OPPORTUNITY = -99,
    COACHED = 0,
    UNCOACHED,
    MISSED,
    NON_OA,
    NON_KPI_COMMITMENT,
}
